import React from 'react';
import { DIMENSIONS } from "utils/Dimensions";
import { DiAsterisk } from "react-icons/di";
import ReactDOMServer from 'react-dom/server';
export default function  NumberColumnRenderer(params) {
  var value = params.value !== undefined ? params.value : "";
  let highlightIconColor = "";
  let highlightDuplicates = false;
  var columnOptions =
    params.columnTypeId == "19" || params.columnTypeId == "7"
      ? typeof params.columnOptions?.formula_column?.options == "object"
        ? params.columnOptions?.formula_column?.options
        : JSON.parse(params.columnOptions?.formula_column?.options)[0]
      : params.columnOptions;


  if (!params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && Number(value) && Number(value) !== 0 && (params.store.duplicateColumnsData[params.colDef.dataIndex] && params.store.duplicateColumnsData[params.colDef.dataIndex][value] && params.store.duplicateColumnsData[params.colDef.dataIndex][value] > 1)) {
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  if (params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && Number(value) && Number(value) !== 0 && (params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][value] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][value] > 1)) {
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  function formatNumberColumn(val, opts) {
    if (opts) {
      let decimals = typeof opts.decimals != "undefined" ? opts.decimals : 2;
      if (typeof opts.number_format != "undefined") {
        return Util.formatNumber(
          Number(val).toFixed(decimals),
          opts.number_format,
          decimals
        );
      }
      return Number(val).toFixed(decimals);
    }
    return Number(val).toFixed(2);
  }

  function formatPercentageColumn(val, opts) {
    if(isNaN(val)){
      return "0 %";
    }
    if (opts) {
      let decimals = typeof opts.decimals != "undefined" ? opts.decimals : 0;
      if (typeof opts.number_format != "undefined") {
        var num = Util.formatNumber(
          Number(val*100).toFixed(opts.decimals-2),
          opts.number_format,
          decimals
        );
        return num+" %";
      }
      return Number(val*100).toFixed(decimals-2)+" %";
    }
    return Number(val*100).toFixed(2)+" %";
  }

  function getFormattedValue() {
    if (
      (params.columnTypeId === "17" ||
        ((params.columnTypeId == 19 || params.columnTypeId == 7) &&
          params.columnOptions.formula_column.column_type_id == 17)) &&
      value &&
      value !== ""
    ) {
      return `${columnOptions["currency_symbol"] ? (columnOptions?.symbol_at_end ? '' : columnOptions["currency_symbol"]) : "$"} ${formatNumberColumn(
        value,
        columnOptions
      )} ${columnOptions?.symbol_at_end ? columnOptions.currency_symbol : ''}`;
    }
    else if(params.columnTypeId === "22"){
      return formatPercentageColumn(value,columnOptions)
    } 
    return formatNumberColumn(value, columnOptions);
  }

  const highlightIcon = ReactDOMServer.renderToStaticMarkup(
    <DiAsterisk style={{
      position: 'absolute',
      top: '5px',
      right: '5px',
      fontSize: '20px'
    }}
    className='highlightIcon'
    color = {highlightIconColor} />
  );

  return `<div
        class="d-flex"
        style="width: ${highlightDuplicates ? Number(params.colDef.width) - 40 : Number(params.colDef.width) - 15}px; height:${
          params.node.rowHeight - 4
        }px; padding-top: ${
          params.node.rowHeight <= DIMENSIONS.cell_height_short && params.node.rowHeight > DIMENSIONS.cell_height_compact ? 0 : 8
        }px; line-height:  ${
          params.node.rowHeight <= DIMENSIONS.cell_height_compact ? "normal" : ""
        }; ${highlightDuplicates ? 'overflow: hidden;' : ''}"
      >
        ${highlightDuplicates ? highlightIcon : ''}
        ${getFormattedValue()}
      </div>`;
}